import { render, staticRenderFns } from "./fontContent.vue?vue&type=template&id=66edcb9f&"
import script from "./fontContent.ts?vue&type=script&lang=js&"
export * from "./fontContent.ts?vue&type=script&lang=js&"
import style0 from "./fontContent.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports